import React from "react";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { ImgBackCardOne } from "../../../assets/logos/icons";
import "./cardMenuHL.css";

const CardMenuHLPure = (props) => {
  const {
    url,
    // toggleDialog,
    altImg,
    imgBackCard,
    img,
    title,
    text,
    text2,
    text3,
    onClick
  } = props;

  let content = <Grid item xs={12} lg={12} md={12} sm={12}>
    <Grid className="cardMenuHL-container">
      <div className="cardMenuHL-img-container">
        {imgBackCard ? (
          <img src={imgBackCard} className="cardMenuHL-img-background" />
        ) : (
          <img src={ImgBackCardOne} className="cardMenuHL-img-background" />
        )}
        <img className="cardMenuHL-icon" alt={altImg} src={img} />
      </div>
      <div className="cardMenuHL-text-card-container">
        <span className="cardMenuHL-title-card">{title}</span>
        <div className="cardMenuHL-body">
          <p
            className={
              text2 || text3
                ? "cardMenuHL-texts-first"
                : "cardMenuHL-text-description"
            }
          >
            {text}
          </p>
          {text2 ? <p className="cardMenuHL-texts-others">{text2}</p> : ""}
          {text3 ? <p className="cardMenuHL-texts-others">{text3}</p> : ""}
        </div>
      </div>
    </Grid>
  </Grid>

  if (onClick) {
    return <button className="cardMenuHL-button" onClick={onClick}>
      {content}
    </button>
  } else {
    return <Link to={url}>
      {content}
    </Link>
  }
};

export { CardMenuHLPure as default };
